/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDownCuteRe: {
  name: 'down-cute-re';
  data: string;
} = {
  name: 'down-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.97 8.42a.968.968 0 0 0-.609.918c.001.305.06.435.498 1.1a17.43 17.43 0 0 0 4.388 4.59c.883.634 1.196.772 1.753.772s.87-.138 1.753-.772a17.43 17.43 0 0 0 4.388-4.59c.438-.665.497-.795.498-1.1.003-.748-.766-1.211-1.442-.868-.186.094-.251.161-.455.47-.132.198-.382.567-.558.82-1.015 1.466-2.518 2.949-3.954 3.899l-.23.152-.23-.152c-1.436-.95-2.939-2.433-3.954-3.899a60 60 0 0 1-.558-.82c-.204-.309-.269-.376-.455-.47-.249-.126-.609-.148-.833-.05"/></svg>`
};
